export default "__VITE_ASSET__D2ZZQ1wJ__"